import { Node, mergeAttributes, wrappingInputRule } from '@tiptap/core';
interface LangEnglishOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    langEnglish: {
      /**
       * Set a langEnglish node
       */
      setLangEnglish: () => ReturnType;
      /**
       * Toggle a langEnglish node
       */
      toggleLangEnglish: () => ReturnType;
      /**
       * Unset a langEnglish node
       */
      unsetLangEnglish: () => ReturnType;
    };
  }
}

const inputRegex = /^\s*>\s$/;

const langEnglishType = 'langEnglish';

const LangEnglish = Node.create<LangEnglishOptions>({
  name: langEnglishType,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  content: 'block+',

  group: 'block',

  defining: true,

  addAttributes() {
    return {
      id: {
        default: null,
      },
      style: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [{ tag: 'lang-english' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'lang-english',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {}),
      0,
    ];
  },

  addCommands() {
    return {
      setLangEnglish: () => ({ commands }) => {
        return commands.wrapIn(this.name);
      },
      toggleLangEnglish: () => ({ commands }) => {
        return commands.toggleWrap(this.name);
      },
      unsetLangEnglish: () => ({ commands }) => {
        return commands.lift(this.name);
      },
    };
  },

  addInputRules() {
    return [
      wrappingInputRule({
        find: inputRegex,
        type: this.type,
      }),
    ];
  },
});

export default { node: LangEnglish, type: langEnglishType };
